import { createEventTracker } from '../util';
import { ClientStorageWarning, PerformanceLongTask, TrialEndedModalAction } from './types';

export const trackClientStorageWarning =
  createEventTracker<ClientStorageWarning>('Client Storage Warning');
export const trackPerformanceLongTask =
  createEventTracker<PerformanceLongTask>('Performance: Long Task');
export const trackTrialEndedModalAction = createEventTracker<TrialEndedModalAction>(
  'Trial Ended Modal Action',
);
